import { useI18n } from "../../i18n";
import { GovernanceListingSection } from "../../components/governance/GovernanceListingSection";
import listStyles from "@/styles/pages/governance/GovernanceListing.module.scss";
import GovernanceEvidence from "../governance/GovernanceEvidence";

export default function ComplianceCenterEvidenceHub() {
  const { t } = useI18n();

  return (
    <div className={listStyles.pageStack}>
      <GovernanceListingSection
        title={t("complianceCenterUi.evidenceHub", "Evidence Hub")}
        description={t(
          "complianceCenterUi.evidenceHubIntro",
          "Manage compliance evidence: upload documents, verify freshness, and link items to policies and controls for audit readiness.",
        )}
      >
        <p className={listStyles.panelSubtitle}>
          {t(
            "gcpEvidence.inTable",
            "Google Cloud configuration evidence is in the evidence items table. Filter Source to Google Cloud. Check result, storage, verification, and freshness are separate.",
          )}
        </p>
      </GovernanceListingSection>
      <GovernanceEvidence />
    </div>
  );
}
